import { createTheme } from '@one-thd/sui-atomic-components';

const THDTreeRootBrown = createTheme({
  palette: {
    mode: 'dark',
    background: {
      primary: 'brand-500'
    }
  }
});

THDTreeRootBrown.palette['--sui-palette-background-primary'] = '63 66 51';

export { THDTreeRootBrown };
